import { Switch as cSwitch } from '@coreui/vue';
import punycode from 'punycode';
import QuickSetup from  '../Site.Quick.Setup'
import reg from '@/reg';
import codes from '@/codes';
import _ from 'lodash';
import result from '../../result_new/result_new.More.i18n'

//restful api
import { site as wmds } from '@/service/api/wmds';
import { result as re } from '@/service/api/wmds';
import { policy as po } from '@/service/api/wmds';

// 초기 필요한 데이터 시작
const default_model = () => ({
  is_alive: true, is_cron: false, is_start: true, is_js: true,
  schedule: [], config: { seeds : [], subs: [], prevents: [] }
});

const policy = {
  S : { depth: 5, links: 20, limit: 200 },
  M : { depth: 10, links: 50, limit: 2000 },
  L : { depth: 20, links: 100, limit: 10000 }
}

const h_txt = {
  EN: {text : ' hour'},
  KO: {text : ' 시간'},
};

const m_txt = {
  EN: {text : ' min'},
  KO: {text : ' 분'},
};

const h_opt = [];

const h_i18n = {
  EN: [
    { value: '*', text: 'every hour' },
    { value: '*/2', text: '2 hour interval'},
    { value: '*/3', text: '3 hour interval'},
    { value: '*/4', text: '4 hour interval'}
  ],
  KO: [
    { value: '*', text: '매 시간' },
    { value: '*/2', text: '2 시간 간격'},
    { value: '*/3', text: '3 시간 간격'},
    { value: '*/4', text: '4 시간 간격'}
  ]
};

const m_opt = [];

const m_i18n = {
  EN: [
    { value: '*', text: 'every min' },
    { value: '*/5', text: '5 min interval'},
    { value: '*/10', text: '10 min interval'},
    { value: '*/15', text: '15 min interval'},
    { value: '*/20', text: '20 min interval'},
    { value: '*/30', text: '30 min interval'},
    { value: '*/45', text: '45 min interval'}
  ],
  KO: [
    { value: '*', text: '매 분' },
    { value: '*/5', text: '5 분 간격'},
    { value: '*/10', text: '10 분 간격'},
    { value: '*/15', text: '15 분 간격'},
    { value: '*/20', text: '20 분 간격'},
    { value: '*/30', text: '30 분 간격'},
    { value: '*/45', text: '45 분 간격'}
  ]
}

// 초기 필요한 끝

export default {
  props : ['is_first'],
  components: { cSwitch, result, QuickSetup },
  filters: {
    cron_filter: function (v) {
      if (!v) return '';
      let vs = v.trim().split(' ');
      let m = _.find(m_opt, { value: vs[0] });
      let h = _.find(h_opt, { value: vs[1] });
      return (h && h.text || vs[1]) + ' ' + (m && m.text || vs[0]);
    }
  },
  computed: {
    is_using_login() {
      return this.model && this.model.el_submit != undefined && this.model.html != undefined
    },
    redir() {
      // console.log(`${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.net' : location.hostname.replace('console.', 'www')}/ToS`)
      return `${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.net' : location.hostname.replace('console.', 'www.')}/ToS`
    },
  },
  data : () => {
    return {
      modal_charge_agree : false,
      msg : '',
      modal_explain : false,
      del_nickname : '',
      codes,
      options : [],
      max_schedule : 10,
      policy : policy,
      v : {},
      isLoadPolicy : false,
      cc : undefined,
      policy_list : [],
      s : { schedule: '0 *', h: '*', h_opt: h_opt, m: '0', m_opt },
      del_confirm: false,
      del_name: false,
      add: false,
      lock: true,
      lock2 : false,
      group_list: undefined,
      model : default_model(),
      result : {},
      confirm_result : false,

      h_txt,
      m_txt
    }
  },
  methods: {
    // load recent result
    load_recent_result() {
      var search = {
        limit: 1,
        offset: 0,
        body: {
          and: [{ name : 'is_del', value: false, op : '='}, { name : 'site_id', value: this.model.id, op : '='}],
          or: [],
          sort: [{ name: 'id', op : 'desc'}]
        }
      }
      // Api.Manager(search)
      re.listResult(search)
        .then(rs => { rs.body && rs.count > 0 ? this.result = rs.body[0] : {}; })
        .catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
    },
    go_result(id) { this.$router.push({ name : 'wmds_result', params : { id : id }}); },

    // ui method
    check_fqdn() {
      try {
        this.model.fqdn = _.trim(this.model.fqdn);
        if(!this.model.fqdn || !reg.domain.test(punycode.toASCII(this.model.fqdn))) { this.$refs.fqdn.$el.focus(); return this.$toastr.w('Domain Check'); }
        if(reg.prevent_domain.test(punycode.toASCII(this.model.fqdn))) { this.$refs.fqdn.$el.focus(); return this.$toastr.w('Domain Type Check'); }
        let seeds = this.model.config.seeds;
        if(!_.includes(seeds, 'http://' + this.model.fqdn) && !_.includes(seeds, 'https://' + this.model.fqdn)) {
          // seeds.push('http://' + );
          this.add_seed('http://' + this.model.fqdn)
        }
        let subs = this.model.config.subs;
        if(_.startsWith(this.model.fqdn, 'www.') && !_.includes(subs, this.model.fqdn.substr(4))) { subs.push(this.model.fqdn.substr(4)); }
        if(!this.model.name) {
          let vn = this.model.fqdn.split('.');
          this.model.name = _.startsWith(this.model.fqdn, 'www.') ? vn[1] : vn[0];
        }
      } catch (e) { console.error(e) }
    },

    // schedule
    schedule_filter: function (v) {
      if (!v) return '';
      return `${v} * * *`
    },

    add_schedule() {
      if(!this.s.schedule) { return this.$toastr.w('select the schedule'); }
      let schedules = this.model.schedule;
      if(_.includes(schedules, this.s.schedule)) { this.s.schedule = undefined; return this.$toastr.i('Already existing'); }
      schedules.push(this.schedule_filter(this.s.schedule)); this.s.schedule = undefined;
      console.info("updated", schedules)
    },
    // TODO : 현재 미사용 처리됨
    // add_schedule_custom() {
    //   if(!this.s.schedule_custom) { return; }
    //   let schedules = this.model.schedule;
    //   if(_.includes(schedules, this.s.schedule_custom)) { this.s.schedule_custom = undefined; return this.$toastr.i('Already existing'); }

    //   // check cron grammar
    //   let arraySche = this.s.schedule_custom.split(' ');
    //   for (let l = 0; l < arraySche.length; l++) {
    //     const e = arraySche[l];
    //     let r = e.split(",")
    //     for (let k = 0; k < r.length; k++) {
    //       const rr = r[k];
    //       // if length is 5, have 5 at lest 6 *
    //       switch (arraySche.length > 4 ? l -1 : l) {
    //         case 0: !(rr <= 59 && rr > 0) ? this.$toastr.e("incorrect cron sec") : ''; break; // sec range 0 ~ 59
    //         case 1: !(rr <= 59 && rr > 0) ? this.$toastr.e("incorrect cron min") : ''; break; // min range 0 ~ 59
    //         case 2: !(rr <= 23 && rr > 0) ? this.$toastr.e("incorrect cron hour") : ''; break; // hour range 0 ~ 23
    //         case 3: !(rr <= 31 && rr > 0) ? this.$toastr.e("incorrect cron day of month") : ''; break; // day of month range 0 ~ 31
    //         case 4: !(rr <= 12 && rr > 0) ? this.$toastr.e("incorrect cron month") : ''; break; // month range 0 ~ 12
    //         case 5: !(rr <= 6 && rr > 0) ? this.$toastr.e("incorrect cron weekday") : ''; break; // weekday range 0 ~ 6
    //         default: console.log("not support "); break;
    //       }

    //     }

    //   }
    //   console.log(schedules, "good")
    //   // schedules.push(this.s.schedule_custom); this.s.schedule_custom = undefined;
    //   console.info("updated", schedules)
    // },
    remove_schedule(a) { this.model.schedule = Object.assign(_.without(this.model.schedule, a)); },

    // seed
    add_seed(url = '') {
      // console.log(this.v.seed, this.model.fqdn, this.v.seed.indexOf(this.model.fqdn) < 0)
      this.v.seed = url ? url : _.trim(this.v.seed);
      // if(!this.v.seed || this.v.seed.indexOf(this.model.fqdn) < 0) { return this.$toastr.w("Start URL does not contain FQDN") }
      let seeds = this.model.config.seeds;
      if(!reg.url_path.test(this.v.seed)) { return this.$toastr.e('URL Check'); }
      if(_.includes(seeds, this.v.seed)) { this.v.seed = undefined; return this.$toastr.i('Already existing'); }
      seeds.push(this.v.seed); this.v.seed = undefined;
    },
    remove_seed(a) { this.model.config.seeds = Object.assign(_.without(this.model.config.seeds, a)); },

    // subs
    add_sub() {
      this.v.sub = _.trim(this.v.sub);
      let subs = this.model.config.subs;
      if(!reg.domain.test(punycode.toASCII(this.v.sub))) { this.$refs.sub_domains.$el.focus(); return this.$toastr.e('Sub Domain Type Check'); }
      if(this.v.sub == this.model.fqdn) { this.v.sub = undefined; return this.$toastr.i('FQDN Check'); }
      if(_.includes(subs, this.v.sub)) { this.v.sub = undefined; return this.$toastr.i('Already existing'); }
      subs.push(this.v.sub); this.v.sub = undefined;
    },
    remove_sub(a) { this.model.config.subs = Object.assign(_.without(this.model.config.subs, a)); },
    add_prevent() {
      this.v.prevent = _.trim(this.v.prevent);
      let prevents = this.model.config.prevents;
      if(!reg.url_path.test(this.v.prevent)) { this.$refs.prevent.$el.focus(); return this.$toastr.e('URL Check'); }
      if(_.includes(prevents, this.v.prevent)) { this.v.prevent = undefined; return this.$toastr.i('Already existing'); }
      prevents.push(this.v.prevent); this.v.prevent = undefined;
    },
    remove_prevent(a) { this.model.config.prevents = Object.assign(_.without(this.model.config.prevents, a)); },
    schedule(e,t) { this.s.schedule = t == 'h' ? `${this.s.m} ${e}` : `${e} ${this.s.h}`; },
    cancel() { this.$router.replace({ name: 'wmds_site', params: { id: this.model.id }}); },
    edit() {
      this.$router.replace({ name: 'wmds_site', params: { id: this.$route.params.id, tag: 'edit' }});
      this.lock = true;
    },

    // site manage
    async remove() {
      try {
        this.del_nickname = (this.del_nickname || '').trim()
        if(this.model.name != this.del_nickname) { return this.$toastr.e('Invalid site name entered');  }
        this.del_nickname = '';
        this.del_confirm = false;
        let rs = await wmds.deleteSite({ id : this.model.id})
        if(rs.error) { return this.$toastr.e(this.$route.name, "failed") }
        this.$emit('refresh'); this.$toastr.s('Removed'); this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText), this.list() }
    },
    list() { this.$router.push({ name : 'wmds_site'}); },
    policy_manage() {  this.$router.replace({ name: 'wmds_policy', params: { id: this.model.policy_id }}); },
    async save() {
      let config = this.model.config;
      if(!this.model.policy_id) { this.$refs.policy.$el.focus(); return this.$toastr.e('Policy ' + 'Required value'); }
      if(!(this.model.fqdn || '').trim()) { this.$refs.fqdn.$el.focus(); return this.$toastr.e('FQDN ' + 'Required value'); }
      if(reg.prevent_domain.test(punycode.toASCII(this.model.fqdn))) { return this.$toastr.e('Domain Type Check'); }
      if(!this.model.schedule.length) { this.$refs.schedule.$el.focus(); return this.$toastr.e('plz, Add Schedule'); }
      if(!config.seeds.length) { return this.$toastr.e('Check start URL Check'); }

      try {
        let rs = await wmds.updateSite(this.model);
        if(rs.error) { return this.$toastr.e("saved failed") }
        this.$toastr.s('Saved'); this.$emit('refresh'); this.cancel();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText)  }
      this.lock = true;
    },
    async change(index){
      try {
        let rs = await po.detailPolicy({ id : index });
        if(rs.error) { return this.$toastr.e("policy load failed") }

        this.policy = rs.body.policy;
        this.policy.description =this.policy.description ? this.policy.description : rs.body.description
        this.model.policy_id = index
        this.isLoadPolicy = true

        console.log("reload", this.policy.description)
      } catch (e) { console.log(e) }
    },
    async get({ id, tag } = this.$route.params) {
      // this part change dynamic loding
      this.add = false;
      let so = {
        body : { sort : [{name : 'id', op : 'desc'}], or : [], and : [{ name : "is_del", value : false, op : '='}] },
      }
      let rs = await po.listPolicy(so);
      if(rs.error) { return this.$toastr.e("load failed") }
      this.policy_list = (rs.body || []).map(r => {
        r.description = r.description
        if(r.description == undefined) { r.description = r.policy.description }
        // console.log(r, 'r')
        return r
      })

      this.lock = (tag !== 'edit');

      if(id == 'add') { this.add = true; this.lock = false; return; }

      let checkPolicyList = _.map(this.policy_list, r => { return r.id })
      this.model = Object.assign({ group: {} }, this.model, (await wmds.detailSite({ id : id })).body);

      if(checkPolicyList.includes(this.model.policy_id)){
        let result = await po.detailPolicy({ id : this.model.policy_id });
        if(result.error) { return this.$toastr.e("load failed") }

        this.policy = Object.assign({}, this.policy, result.body.policy, { description : result.body.description })
        if(this.policy.description == undefined) { this.policy.description = result.body.policy.description }
        this.isLoadPolicy = true;
      }
      this.load_recent_result()
    },
    refresh() { this.$emit('refresh') },
    async charge_agree() {
      try {
        let rs = await wmds.agreeSite({ ts : new Date().getTime() });
        if(rs.error) { return this.$toastr.e("apply agreement failed") }
        // 시스템 로그가 남아야 함, 동의 부분 관련
        this.save()
      } catch (e) { console.log(e); this.$toastr.e("apply agreement failed") }

    },

    //일정 확인 한글화 진행을 위한 hour쪽 method
    h_fields(){
      let h_f = h_i18n[this.i18n]
      //중복으로 들어가는것을 막기위해서
      h_opt.splice(0,28)

      for(let value in h_f){
        let h = h_f[value]

        h_opt.push(h)
      }
    },
    h_time(){
      let h = this.h_txt[this.i18n]

      for(let value in h){
        let time = h[value]

        return time
      }
    },
    h_hour(){
      this.h_fields()
      for(let i = 0; i < 24; i++) { h_opt.push({ value: i.toString(), text: i + `${this.h_time()}` }); }
    },

    //일정 확인 한글화 진행을 위한 min쪽 method
    m_fields(){
      let m_f = m_i18n[this.i18n]
      //중복으로 들어가는것을 막기위해서
      m_opt.splice(0,67)

      for(let value in m_f){
        let m = m_f[value]

        m_opt.push(m)
      }
    },
    m_time(){
      let m = this.m_txt[this.i18n]

      for(let value in m){
        let time = m[value]

        return time
      }
    },
    m_min(){
      this.m_fields()

      for(let i=0; i < 60; i++){ m_opt.push({ value: i.toString(), text: i + `${this.m_time()}`})}
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); console.log(from.path) } },
  created: function() { console.log('site.detail.vue', 'created'); },
  destroyed: function() { console.log('site.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('site.detail.vue', 'mounted');
    this.get(this.$route.params);
    this.h_hour()
    this.m_min()
  },
}